module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAG1BMVEVHcEz///////////////////////////////8W/R0OAAAACXRSTlMAH0thcn8sEjsbvWBMAAAAuklEQVR42n2TQYLEIAgEV+hS///icVZjxznIKd1gEQz521EiBcooy3BUsUP1SLUEFL3WHgKyvYiCLFslyAo4SBUoiylkzI+V0BZPWvQGuRh1w2YDuyKfYvUueHgarKd3/7cb9CGWH2i+RExCElOLsCiqy3OxvhhH7An7QB7zJ5C+iSPZYECdPLBtMo1N4p1s7k56FCc9Snmjih+nL9JHfTCRr/jA2k1bksvy+rFva3JfsPtq3pf6+jt8AKYlBelSZKT6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/mark.png
// module id = Muc2
// module chunks = 216